import request from '@/utils/request'

export function getBottleInfo(params) {
  return request({
    url: '/bottle/roam/'+params.bottleId,
    method: 'get'
  })
}

export function getBottleRoam(params) {
  return request({
    url: '/bottle/scan/'+params.bottleId,
    method: 'get',
    params: {
      page: params.page,
    }
  })
}

export function getPartsFlow(params) {
  return request({
    url: 'wxagent/material-flow/'+params.bottleId,
    method: 'get',
    params: {
      page: params.page,
    }
  })
}